<template>
  <label class="flex items-center gap-2 text-xs text-gray-500">
    <span class="uppercase tracking-wider font-semibold text-[10px]">Year</span>
    <select
      :value="modelValue"
      class="px-2 py-1 text-xs border border-gray-300 rounded bg-white font-medium text-gray-900 focus:outline-none focus:ring-1 focus:ring-primary-500"
      @change="$emit('update:modelValue', Number($event.target.value))"
    >
      <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
    </select>
  </label>
</template>

<script>
export default {
  name: 'YearSelector',
  props: {
    modelValue: { type: Number, default: null },
    years: { type: Array, required: true },
  },
  emits: ['update:modelValue'],
};
</script>
